

export const OVERVIEW_SET_CUSTOM_UNIT_INFO = "OVERVIEW_SET_CUSTOM_INFO"; // 设置用电单位概览信息

/**
 * 设置客户单位信息
 */
export const setCustomUnitInfo = (customInfo) => {
    return {
        type: OVERVIEW_SET_CUSTOM_UNIT_INFO,
        customUnitInfo: customInfo
    }
}
